export const EMAIL_SUPPORT = 'support@crossref.org';
export const EMAIL_CONTENT_REGISTRATION_ROLE_DEPOSITOR =
  'content-registration-form@crossref.org';
export const EMAIL_CONTENT_REGISTRATION_DEPOSITOR_UNKNOWN =
  'content-registration-form+unknown-depositor@crossref.org';
export const EMAIL_GENERIC_CONTENT_REGISTRATION_MR =
  'content-registration-form+mr@crossref.org';
export const NAME_CONTENT_REGISTRATION_DEPOSITOR_UNKNOWN = 'Unknown Depositor';
